// extracted by mini-css-extract-plugin
module.exports = {"slider_slide":"style_slider_slide__qtepA","desktop_card_square":"style_desktop_card_square__CugYt"};